import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from '#src/shared/prefetch';

import {
	LocationSitemapPageContextProvider,
	type LocationSitemapPagePrefetchedDataProps,
	prefetchPageContext,
} from '#src/app/pages/local/sitemap/pageContext';

import { Layout } from '../layout';

import { LocationSitemapErrorHandler } from './ErrorHandler';

export const LocationSitemap = withPrefetchedData(
	function LocationSitemap({ prefetchedData }: LocationSitemapPagePrefetchedDataProps) {
		return (
			<LocationSitemapPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={LocationSitemapErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</LocationSitemapPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
		// FIXME: i18n
		pageTitle: ({ fromTemplate }) => fromTemplate('Browse by Location'),
		pageMetadata: ({ pageTitle }) => ({
			// FIXME: i18n
			description:
				'Find petitions near you and support local change. Explore what\u2019s happening in your community on Change.org.',
			ogTitle: pageTitle,
			ogType: 'website',
			twitterImageAlt: pageTitle,
		}),
	},
);
